<template>
  <el-dialog class="month-card-rule" :visible.sync="visible" :class="{ 'mobile-edit': editing && $store.getters.isMobile }" :modal="!editing" :modal-append-to-body="false" :width="$store.getters.isMobile ? mobileWidth : '520px'">
    <div class="content">
      <rich-text v-model="model.ruleTitle" class="title mb-4" :editing="editing"/>
      <rich-text v-model="model.ruleText" class="subtitle" :editing="editing" />
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from "element-ui";
import RichText from "~/components/richText/index.vue";

export default {
  name: 'MonthCardRule',
  components: {
    RichText,
    [Dialog.name]: Dialog
  },
  props: {
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    mobileWidth() {
      return (this.editing && this.$store.getters.isMobile) ? '320px' : '90%'
    }
  },
  methods: {
    init() {
      this.visible = true
    }
  }
}
</script>

<style lang="less">
.month-card-rule {
  &.mobile-edit {
    .el-dialog {
      left: 10px;
    }
  }
  .rich-text.focus-editor .ql-container.ql-snow {
    background-color: transparent;
  }
  .el-dialog__header {
    font-weight: bold;
    text-align: center;
    padding: 0;
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
    }
    .el-dialog__title {
      font-size: 18px;
    }
  }
}
</style>
